import { render, staticRenderFns } from "./PersonGroupPage.vue?vue&type=template&id=7bc9c4c4&"
import script from "./PersonGroupPage.vue?vue&type=script&lang=js&"
export * from "./PersonGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonGroupPage.vue?vue&type=style&index=0&id=7bc9c4c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports